
/**
 * 
 * @export
 * @interface ZoppmPodmienkaSpecRef
 */
export interface ZoppmPodmienkaSpecRef {
    /**
     * 
     * @type {string}
     * @memberof ZoppmPodmienkaSpecRef
     */
    'podmienka'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZoppmPodmienkaSpecRef
     */
    'typ'?: ZoppmPodmienkaSpecRefTypEnum;
    /**
     * 
     * @type {string}
     * @memberof ZoppmPodmienkaSpecRef
     */
    'zoppmPodmienkaSpecId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZoppmPodmienkaSpecRef
     */
    'zoppmSpecId'?: string;
}

export const ZoppmPodmienkaSpecRefTypEnum = {
    UcelPouzitiaProstriedkovMechanizmu: 'UCEL_POUZITIA_PROSTRIEDKOV_MECHANIZMU',
    PodmienkyOpravnenostiZiadatela: 'PODMIENKY_OPRAVNENOSTI_ZIADATELA',
    PodmienkyDoruceniaZiadosti: 'PODMIENKY_DORUCENIA_ZIADOSTI',
    PodmienkyStatnejPomoci: 'PODMIENKY_STATNEJ_POMOCI',
    DalsiePodmienkyZOsobitnychPredpisov: 'DALSIE_PODMIENKY_Z_OSOBITNYCH_PREDPISOV',
    DalsiePodmienkyPoskytnutiaProstriedkovMechanizmu: 'DALSIE_PODMIENKY_POSKYTNUTIA_PROSTRIEDKOV_MECHANIZMU'
} as const;

export type ZoppmPodmienkaSpecRefTypEnum = typeof ZoppmPodmienkaSpecRefTypEnum[keyof typeof ZoppmPodmienkaSpecRefTypEnum];


